import script from "./TeamMemberSelectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamMemberSelectModal.vue?vue&type=script&lang=ts&setup=true"

import "./TeamMemberSelectModal.vue?vue&type=style&index=0&id=647575c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647575c7"]])

export default __exports__